import { CxEvent } from '@spartacus/core';

export class FbqGgCheckoutShippingAddressSelectedEvent extends CxEvent {
  event?: string;
}
